import {
  AsymmetryScalingThresholds,
  AsymmetryScalingThresholdsClass,
} from './body-thresholds.model';

export interface AsymmetryVariableRanges {
  id: string;
  longeing: AsymmetryScalingThresholds;
  straight: AsymmetryScalingThresholds;
}

export class AsymmetryVariableRangesClass implements AsymmetryVariableRanges {
  id: string;
  longeing: AsymmetryScalingThresholds;
  straight: AsymmetryScalingThresholds;

  constructor(o: any = {}) {
    this.id = o['id'] ?? null;
    this.longeing = new AsymmetryScalingThresholdsClass(o['longeing']);
    this.straight = new AsymmetryScalingThresholdsClass(o['straight']);
  }
}
